<div class="min-h-screen bg-gray-50 p-4 md:p-6 font-sans">
  


  <!-- MAIN NAVIGATION TABS -->
  <div class="bg-white p-2 rounded-lg shadow-sm border border-gray-200 mb-6 flex flex-wrap gap-2">
    
    <!-- Sales Tab -->
    <button (click)="switchTab('sales')"
      [class]="currentTab === 'sales' ? 'bg-yellow-600 text-white shadow-md' : 'bg-transparent text-gray-600 hover:bg-gray-100'"
      class="flex-1 py-3 px-6 rounded-md font-semibold transition-all duration-300 text-sm uppercase tracking-wider">
      Sales Dashboard
    </button>

    <!-- Stock Tab -->
    <button (click)="switchTab('stock')"
      [class]="currentTab === 'stock' ? 'bg-yellow-600 text-white shadow-md' : 'bg-transparent text-gray-600 hover:bg-gray-100'"
      class="flex-1 py-3 px-6 rounded-md font-semibold transition-all duration-300 text-sm uppercase tracking-wider">
      Stock Dashboard
    </button>

    <!-- Profit & Loss Tab -->
    <button (click)="switchTab('accounts')"
      [class]="currentTab === 'accounts' ? 'bg-yellow-600 text-white shadow-md' : 'bg-transparent text-gray-600 hover:bg-gray-100'"
      class="flex-1 py-3 px-6 rounded-md font-semibold transition-all duration-300 text-sm uppercase tracking-wider">
      Profit & Loss Dashboard
    </button>

    <!-- Staff Tab -->
    <button (click)="switchTab('staff')"
      [class]="currentTab === 'staff' ? 'bg-yellow-600 text-white shadow-md' : 'bg-transparent text-gray-600 hover:bg-gray-100'"
      class="flex-1 py-3 px-6 rounded-md font-semibold transition-all duration-300 text-sm uppercase tracking-wider">
      Staff Dashboard
    </button>
  </div>

  <!-- DYNAMIC CONTENT AREA -->
  <div class="animate-fade-in-up">
    <app-sales-dashboard *ngIf="currentTab === 'sales'"></app-sales-dashboard>
    <app-stock-dashboard *ngIf="currentTab === 'stock'"></app-stock-dashboard>
    <app-accounts-dashboard *ngIf="currentTab === 'accounts'"></app-accounts-dashboard>
    <app-staff-dashboard *ngIf="currentTab === 'staff'"></app-staff-dashboard>
  </div>

</div>